'use client';

import Script from 'next/script';
import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    turnstile?: {
      render: (
        container: HTMLElement,
        opts: {
          sitekey: string;
          theme?: 'light' | 'dark' | 'auto';
          appearance?: 'always' | 'execute' | 'interaction-only';
          'response-field-name'?: string;
        }
      ) => string;
      reset: (widgetId?: string) => void;
    };
  }
}

const SITE_KEY = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY;

export function TurnstileWidget() {
  const ref = useRef<HTMLDivElement | null>(null);
  const widgetIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!SITE_KEY || !ref.current) return;
    if (window.turnstile && !widgetIdRef.current) {
      widgetIdRef.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        theme: 'dark',
        appearance: 'interaction-only',
        'response-field-name': 'cf-turnstile-response',
      });
    }
  }, []);

  if (!SITE_KEY) return null;

  return (
    <>
      <Script
        src="https://challenges.cloudflare.com/turnstile/v0/api.js"
        strategy="afterInteractive"
        onLoad={() => {
          if (ref.current && window.turnstile && !widgetIdRef.current) {
            widgetIdRef.current = window.turnstile.render(ref.current, {
              sitekey: SITE_KEY,
              theme: 'dark',
              appearance: 'interaction-only',
              'response-field-name': 'cf-turnstile-response',
            });
          }
        }}
      />
      <div ref={ref} aria-hidden="true" />
    </>
  );
}
